import mainLogo from '../../images/Pampa/pampa_logo_color.png';
import squareLogo from '../../images/Pampa/pampa_logo_color_square.png';
import bannerLogoWhite from '../../images/Pampa/pampa_logo_white.png';
import banner01 from '../../images/Pampa/pampa_bg_01.jpg';
import banner02 from '../../images/Pampa/pampa_bg_02.jpg';
import banner03 from '../../images/Pampa/pampa_bg_03.jpg';
import car123 from '../../images/Pampa/123_nivus.jpg';
import box123 from '../../images/Pampa/123_vw.jpg';
import {SliderProducts} from '../../Utilities/SliderProducts';

export const configData = {
    defaultStore: 'Pampa',
    defaultStoreLink: 'pecas.pampaveiculos.com.br',
    defaultContactEmail: 'pecas.pampa@pampaveiculos.com.br',
    whatsappNumber: '54 2104 6600',
    CNPJname: 'PAMPA SERVICOS E AUTO PECAS LTDA',
    CNPJ: '92.021.005/0001-19',
    CNPJaddress: 'Av. Brasil Oeste, 3730 - Boqueirão, Passo Fundo - RS, 99.025-604',
    launchDate: '01/04/2025',

    multiContact: {},
    searchByPlate: false,

    coupons: [
        // {
        //     coupon: '10PORCENTO',
        //     discountPrice: 0,
        //     discountPercent: 0.1,
        //     freeShipping: false,
        // },
        // {
        //     coupon: '10REAIS',
        //     discountPrice: 10,
        //     discountPercent: 0,
        //     freeShipping: false,
        // },
        // {
        //     coupon: 'FRETEGRATIS',
        //     discountPrice: 0,
        //     discountPercent: 0,
        //     freeShipping: true,
        // },
    ],

    brands: [
        'volkswagen',
    ],

    homologBrands: [
        'motorcraft',
        'motrio',
        'acdelco',
        'mopar',
        'bproauto',
    ],

    noVehicle: false,

    storeSellersWarehouses: [
        "PAMPA VW MATRIZ",
    ],
    
    disabledSellers: [],

    useMktNames: false,

    endYear: 2025,
    startYear: 1996,

    payment: {
        maxParcels: 6,
        checkoutParcels: {
            0: 1,
            200: 2,
            300: 3,
            600: 4,
            800: 5,
            1000: 6,
        }
    },

    customShipping: {
        deliveryTime: 1,
    },

    productSlider: [
        {
            name: 'Kits',
            img: 'tabKits',
            products: SliderProducts.Kits
        },
        {
            name: 'Óleos',
            img: 'tabOleos',
            products: SliderProducts.Oleos
        },
        {
            name: 'Filtros',
            img: 'tabFiltros',
            products: SliderProducts.Filtros
        },
        {
            name: 'Acessórios',
            img: 'tabAcessorios',
            products: SliderProducts.Acessorios
            },
        {
            name: 'Roupas',
            img: 'tabRoupas',
            products: SliderProducts.Roupas
        }
    ]
}

export const contentData = {
    mainLogo: mainLogo,
    squareLogo: squareLogo,
    bannerLogoWhite: bannerLogoWhite,

    banner01: banner02,
    banner02: banner03,
    banner03: '',
    banner04: '',
    bannerBrands: '',
    aboutUsBg: banner01,

    box123: box123,
    car123: car123,
    
    paymentImg: squareLogo,
    paymentImgMobile: squareLogo,

    bannerSpecial: '',
    bannerSpecialMobile: '',
    imgSepcial: '',
    imgSepcialMobile: '',

    bannerHighlight: 'Compre peças originais <span style="font-weight: bold;">Volkswagen</span> direto das concessionárias <span style="font-weight: bold;">Pampa</span>.',
    aboutUs: {
        title: 'Sobre nós',
        content: [
            'VOCÊ CONHECE A VOLKSWAGEN. CONHEÇA AGORA A PAMPA VOLKSWAGEN.',
            'A Volkswagen é uma das líderes mundiais em produção de veículos, é a maior produtora de veículos da Europa, a maior exportadora do Brasil e tem o maior portfólio de produtos. Também é a que mais cresce, porque encanta e fideliza clientes por onde passa.'
        ],
        link: 'https://volkswagenpampa.com.br/sobre-nos/',
        linkCta: 'Saiba mais',
    },

    socialMedia: {
        Instagram: 'https://www.instagram.com/vwpampa/',
        Facebook: '',
        LinkedIn: 'https://br.linkedin.com/company/pampavolkswagen',
        Youtube: 'https://www.youtube.com/channel/UCUf7qNkGiJQbDRQlpfBmNsA',
        Twitter: '',
    },

    footerContent: [],
}